<script>
export default {
    props: {
        size: {
            default: 'tw-w-4 tw-h-4',
            type: String,
        },
        icon: String,
    },
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" v-bind:class="[size]">
        <g v-if="icon === 'alert'">
            <path d="M15.73,13,9.21,1.79A1.4,1.4,0,0,0,8,1a1.43,1.43,0,0,0-1.21.82L.26,13a1.4,1.4,0,0,0-.11,1.44,1.39,1.39,0,0,0,1.3.62H14.56a1.45,1.45,0,0,0,1.3-.62A1.43,1.43,0,0,0,15.73,13Zm-.5,1.08a.72.72,0,0,1-.67.27H1.45a.77.77,0,0,1-.68-.27.73.73,0,0,1,.11-.73L7.43,2.14c.18-.3.4-.46.59-.46a.79.79,0,0,1,.59.46l6.52,11.18a.75.75,0,0,1,.1.73ZM8.54,11.47A.54.54,0,1,1,8,10.94.53.53,0,0,1,8.54,11.47Zm0-5.16V9.69a.54.54,0,1,1-1.07,0V6.31a.54.54,0,1,1,1.07,0Z" />
        </g>
        <g v-if="icon === 'arrow'">
            <path d="M.1,5.42l7.67,7.73a.32.32,0,0,0,.46,0L15.9,5.47a.27.27,0,0,0,.1-.22A.29.29,0,0,0,15.9,5L13.8,2.85a.29.29,0,0,0-.23-.09.36.36,0,0,0-.24.09L8,8.18,2.68,2.85a.34.34,0,0,0-.47,0h0L.1,5a.31.31,0,0,0,0,.44Z" transform="translate(0)" />
        </g>
        <g v-if="icon === 'calendar'">
            <path d="M11.93,3.39A1.12,1.12,0,0,0,13,2.28h0V1.12a1.11,1.11,0,1,0-2.22,0V2.28a1.11,1.11,0,0,0,1.1,1.11Z" transform="translate(0)" />
            <path d="M15.86,1.92H13.63v.57a1.69,1.69,0,1,1-3.38.07V1.92H5.75v.57a1.69,1.69,0,1,1-3.38.07V1.92L.12,1.9V16H15.88Zm-1.11,13H1.25v-9h13.5v9Z" transform="translate(0)" />
            <path d="M4,3.39A1.11,1.11,0,0,0,5.15,2.28h0V1.12A1.11,1.11,0,0,0,4.05,0,1.09,1.09,0,0,0,2.94,1.1V2.28A1.11,1.11,0,0,0,4,3.39Z" transform="translate(0)" />
            <rect x="5.75" y="7.08" width="1.77" height="1.57" />
            <rect x="8.62" y="7.08" width="1.77" height="1.57" />
            <rect x="11.28" y="7.08" width="1.77" height="1.57" />
            <rect x="5.75" y="9.68" width="1.77" height="1.57" />
            <rect x="8.62" y="9.68" width="1.77" height="1.57" />
            <rect x="11.28" y="9.68" width="1.77" height="1.57" />
            <rect x="5.75" y="12.33" width="1.77" height="1.57" />
            <rect x="2.94" y="9.68" width="1.77" height="1.57" />
            <rect x="2.94" y="12.33" width="1.77" height="1.57" />
            <rect x="8.62" y="12.33" width="1.77" height="1.57" />
            <rect x="11.28" y="12.33" width="1.77" height="1.57" />
        </g>
    </svg>
</template>
